import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';
import { arsEndpointSettings } from './setup';

/**
 * Generates a unique id for the referrer
 * @param {object} params - an object of params
 * @param {string} params.accessToken - User IMS token
 * @param {string} params.appId - Id of the app
 * @param {string} params.versionId - Version of the app
 * @param {string} params.appType - Type of the app
 * @param {string} [params.orgId] - OrgId of the app (required for ABD apps)
 * @param {AbortSignal} signal - Optional abort signal for cancelling the request
 */
export default async (params = {}, signal = null) => {
  const isABD = params.appType === 'ABD';
  const requiredParams = ['appId', 'versionId', 'appType', 'accessToken'];
  if (isABD) {
    requiredParams.push('orgId');
  }
  const paramsRules = {
    appId: { allowedTypes: ['string'] },
    versionId: { allowedTypes: ['string'] },
    appType: { allowedTypes: ['string'] },
    accessToken: { allowedTypes: ['string'] },
    orgId: { allowedTypes: ['string'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const queryParams = new URLSearchParams({
    appId: params.appId,
    appVersionId: params.versionId,
    appType: params.appType,
  });
  
  if (isABD) {
    queryParams.set('orgId', params.orgId);
  }

  const response = await fetch(
    `${arsEndpointSettings.endpoint}/entitlement-api/v2/commerce/generateUniqueId?${queryParams}`,
    {
      signal,
      headers: { Authorization: params.accessToken, 'x-api-key': arsEndpointSettings.apiKey },
    }
  );
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return content;
  }
};
